import React, { useState, useEffect } from "react";
import Sidebar from "../../common/Sidebar/Sidebar";
import Header from "../../common/Header/Header";
import action from "../../asessts/Images/arrow_left.svg";
import client from "../../services/Client";
import { useParams } from "react-router-dom";
import Loading from "../../common/Loading/Loading";
import toast from "react-hot-toast";
import BlockModal from "../../common/Modal/BlockModal";
import UnBlockModal from "../../common/Modal/UnBlockModal";
import actionEye from "../../asessts/Images/action_eye.svg";
import eyeClose from "../../asessts/Images/eye_close.svg";

function ItemDetail() {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [item, setItem] = useState({});
  const [isPassLoading, setIsPassLoading] = useState(false);

  const [showBlockModal, setShowBlockModal] = useState(false);
  const [showUnBlockModal, setShowUnBlockModal] = useState(false);

  const handleHide = () => {
    setShowBlockModal(true);
    setShowOverlay(true);
  };

  const handleUnhide = () => {
    setShowUnBlockModal(true);
    setShowOverlay(true);
  };

  const confirmHide = async (itemId) => {
    try {
      setIsPassLoading(true);
      await client.put(`/app/admin/items/hide-item/${itemId}`, {
        hideItem: true,
      });
      toast.success("Item hidden successfully");
      fetchItemDetails();
    } catch (error) {
      toast.error(error.response?.data?.message || "Error hiding item");
    } finally {
      setShowBlockModal(false);
      setShowOverlay(false);
      setIsPassLoading(false);
    }
  };

  const confirmUnhide = async (itemId) => {
    try {
      setIsPassLoading(true);
      await client.put(`/app/admin/items/hide-item/${itemId}`, {
        hideItem: false,
      });
      toast.success("Item unhidden successfully");
      fetchItemDetails();
    } catch (error) {
      toast.error(error.response?.data?.message || "Error unhiding item");
    } finally {
      setShowUnBlockModal(false);
      setShowOverlay(false);
      setIsPassLoading(false);
    }
  };
  const cancelDelete = () => {
    setShowBlockModal(false);
    setShowUnBlockModal(false);
    setShowOverlay(false);
  };

  const fetchItemDetails = async () => {
    try {
      setIsLoading(true);
      const response = await client.get(
        `/app/admin/items/total-items-listed/${id}`
      );
      setItem(response.data.response || {});
    } catch (error) {
      console.error("Error fetching item details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchItemDetails();
  }, [id]);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="admin-dashboard">
      <Sidebar />
      <div className="main-dashboard subadmin-dashboard">
        <Header imageUrl={action} title={"Item Details"} />

        <div className="loaction-list-main">
          {isLoading ? (
            <Loading />
          ) : (
            <div className="order-tracking-main item-details-main">
              <div className="tracking-left">
                <div
                  className="head"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "10px",
                  }}
                >
                  <h3>Item Details</h3>

                  <div>
                    <button
                      onClick={() =>
                        item?.hideByAdmin ? handleUnhide() : handleHide()
                      }
                      disabled={isPassLoading}
                      className={`hide-eye-btn ${
                        item?.hideByAdmin ? "border-dark" : ""
                      }`}
                    >
                      <img
                        src={item?.hideByAdmin ? eyeClose : actionEye}
                        alt={item?.hideByAdmin ? "Unhide" : "Hide"}
                      />
                    </button>
                  </div>
                </div>

                <div className="details">
                  <div className="input-group">
                    <div className="input-field">
                      <label>Title</label>
                      <input
                        type="text"
                        value={item?.category || ""}
                        readOnly
                      />
                    </div>

                    <div className="input-field">
                      <label>Lender Name</label>
                      <input
                        type="text"
                        value={item?.lenderDetails?.name || ""}
                        readOnly
                      />
                    </div>

                    <div className="input-field">
                      <label>Lender Email</label>
                      <input
                        type="text"
                        value={item?.lenderDetails?.email || ""}
                        readOnly
                      />
                    </div>

                    <div className="input-field">
                      <label>Lender Address</label>
                      <input
                        type="text"
                        value={item?.lenderDetails?.address || ""}
                        readOnly
                      />
                    </div>

                    <div className="input-field">
                      <label>Listing Date</label>
                      <input
                        type="text"
                        value={formatDate(item?.listingDate)}
                        readOnly
                      />
                    </div>

                    <div className="input-field">
                      <label>Brand</label>
                      <input
                        type="text"
                        value={item?.brand?.name || ""}
                        readOnly
                      />
                    </div>

                    <div className="input-field">
                      <label>Size</label>
                      <input
                        type="text"
                        value={[
                          ...(item?.size?.eu || []),
                          ...(item?.size?.uk || []),
                          ...(item?.size?.footwear || []),
                        ].join(", ")}
                        readOnly
                      />
                    </div>

                    <div className="input-field">
                      <label>Status</label>
                      <input type="text" value={item?.status || ""} readOnly />
                    </div>

                    <div className="input-field">
                      <label>Total Rentals To Date</label>
                      <input
                        type="text"
                        value={item?.totalRentsToDate ?? ""}
                        readOnly
                      />
                    </div>

                    <div className="input-field">
                      <label>Rental Price Per Day</label>
                      <input
                        type="text"
                        value={
                          item?.rentalPricePerDay != null
                            ? `${item.rentalPricePerDay} €`
                            : 0 + " €"
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {showOverlay && <div className="overlay"></div>}

      <BlockModal
        isOpen={showBlockModal}
        onClose={cancelDelete}
        SuccessMessage="Please confirm!"
        ModalMessage="Are you sure you want to Hide?"
        onConfirmBlock={() => confirmHide(id)}
        changeLoading={isPassLoading}
      />

      <UnBlockModal
        isOpen={showUnBlockModal}
        onClose={cancelDelete}
        SuccessMessage="Please confirm!"
        ModalMessage="Are you sure you want to Un-Hide?"
        onConfirmBlock={() => confirmUnhide(id)}
        changeLoading={isPassLoading}
      />
    </div>
  );
}

export default ItemDetail;
